import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Inject } from '@angular/core';
import { SeoAlternateUrl } from '@biletix/core/services/seo-url.service';

@Injectable({
  providedIn: 'root',
})
export class CanonicalService {
  private renderer: Renderer2;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private rendererFactory: RendererFactory2
  ) {
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  setCanonicalUrl(url: string): void {
    let link = this.document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;

    if (link) {
      
      this.renderer.setAttribute(link, 'href', url);
    } else {
     
      link = this.renderer.createElement('link');
      this.renderer.setAttribute(link, 'rel', 'canonical');
      this.renderer.setAttribute(link, 'href', url);
      this.renderer.appendChild(this.document.head, link);
    }
  }

  /**
   * Sayfanın dil varyantlarını `<link rel="alternate" hreflang="...">` olarak yazar.
   *
   * `setCanonicalUrl`'den farklı olarak burada tek bir etiket güncellenemez: dil
   * sayısı sayfaya göre değişebilir ve SPA gezinmesinde önceki sayfanın etiketleri
   * DOM'da kalır. Bu yüzden mevcut hreflang etiketleri önce silinir, sonra yenileri
   * eklenir — aksi halde her gezinmede birikirler.
   */
  setAlternateUrls(alternates: SeoAlternateUrl[]): void {
    this.clearAlternateUrls();

    alternates.forEach((alternate) => {
      const link = this.renderer.createElement('link');
      this.renderer.setAttribute(link, 'rel', 'alternate');
      this.renderer.setAttribute(link, 'hreflang', alternate.hreflang);
      this.renderer.setAttribute(link, 'href', alternate.url);
      this.renderer.appendChild(this.document.head, link);
    });
  }

  private clearAlternateUrls(): void {
    const links = this.document.querySelectorAll('link[rel="alternate"][hreflang]');
    links.forEach((link) => this.renderer.removeChild(this.document.head, link));
  }
}
